import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #000;
    border: none;
    color: #fff;
  }
  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    width: 100%;
    h1 {
      font-size: 18px;
      font-weight: 600;

      @media (min-width: 1280px) {
        font-size: 24px;
      }
    }
  }
  .modal-header {
    padding: 8px;
    border: none;
    background: rgba(0, 0, 0, 0);
   
    button.close {
      opacity: 1;
      padding: 4px auto !important;
      z-index: 100;
      position: absolute;
      top: -3%;
      right: -3%;
      span {
        font-weight: 400;
        font-size: 48px;
        color: #f8c605;
        text-shadow: none;
      }
    }
  }
`

export default function ComingSoonModal({ showModal, hideModal }) {
  return (
    <StyledModal
      show={showModal}
      onHide={hideModal}
      size="xl"
      centered
    >
      <Modal.Header closeButton />

      <Modal.Body>
        <div className="modal-content" >
            <h1>Coming Soon...</h1>
        </div>
      </Modal.Body>
    </StyledModal>
  )
}
